import React from 'react';
import { Radio, RadioGroup, Text } from 'rsuite';
import { ValueType } from 'rsuite/esm/Radio';
import { HOA_OPTIONS } from 'src/components/payment/constants';
import FormFieldErrorIcon from '../FormFieldErrorIcon';

interface HoaRadioGroupProps {
  disabled?: boolean;
  error?: string;
  onChange: (value: HOA_OPTIONS) => void;
  value?: HOA_OPTIONS;
}

export const HoaRadioGroup = ({
  disabled = false,
  error,
  onChange,
  value,
}: HoaRadioGroupProps) => {
  const handleChange = (value: ValueType) => {
    onChange(value as HOA_OPTIONS);
  };

  return (
    <fieldset style={{ border: 'none', margin: 0, padding: 0 }}>
      <legend>
        <Text>
          Is there a functioning Home Owner&apos;s Association (HOA) for this
          property?
        </Text>
      </legend>
      <RadioGroup
        name="hoa-radio-option-group"
        value={value}
        onChange={handleChange}
        disabled={disabled}
        aria-invalid={error ? true : undefined}
      >
        <Radio value={HOA_OPTIONS.YES}>Yes</Radio>
        <Radio value={HOA_OPTIONS.NO}>No</Radio>
      </RadioGroup>
      {error && <FormFieldErrorIcon errorMessage={error} />}
    </fieldset>
  );
};
